class CampaignsDelegate {
    setIsOpen(isOpen) {
        this.setState((prevState) => {
            return {
                isOpen,
                editMode: false,
                editingCampaign: null
            };
        });
    }

    setRows(rows) {
        this.setState((prevState) => {
            return { rows };
        });
    }
}

export default CampaignsDelegate;
